import "../css/header.scss";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";

function Header() {
  const { cartItems } = useContext(CartContext);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <header className="site-header">
      <div className="site-header__left">
        <nav className="site-header__nav" aria-label="Primary">
          <Link className="site-header__nav-link" to="/shop">
            Shop All
          </Link>
          <Link className="site-header__nav-link" to="/about">
            About Us
          </Link>
          <Link className="site-header__nav-link" to="/contact">
            Help Center
          </Link>
        </nav>
      </div>

      <div className="site-header__center">
        <Link
          className="site-header__logo"
          to="/"
          onClick={toTop}
          aria-label="mvandora home"
        >
          <span className="site-header__logo-mark" aria-hidden="true">
            <span className="site-header__logo-stripe site-header__logo-stripe--1" />
            <span className="site-header__logo-stripe site-header__logo-stripe--2" />
            <span className="site-header__logo-stripe site-header__logo-stripe--3" />
            <span className="site-header__logo-stripe site-header__logo-stripe--4" />
          </span>
          <span className="site-header__logo-text">mvandora</span>
        </Link>
      </div>

      <div className="site-header__right">
        <Link
          className="site-header__icon-btn"
          to="/cartpage"
          aria-label={
            cartItems?.length
              ? `Shopping cart, ${cartItems.length} items`
              : "Shopping cart"
          }
        >
          <svg
            className="site-header__icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M6 8h15l-1.5 9H7.5L6 8z" />
            <path d="M6 8L5 3H2" />
            <path d="M9 21a1 1 0 100-2 1 1 0 000 2zM18 21a1 1 0 100-2 1 1 0 000 2z" />
          </svg>
        </Link>
      </div>
    </header>
  );
}

export default Header;
